import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#0b57d0', // Google Blue G400 equivalent
            light: '#d3e3fd',
            dark: '#0842a0',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#c2e7ff', // Google Light Blue
            light: '#f1f8ff',
            dark: '#004a77',
            contrastText: '#001d35',
        },
        background: {
            default: '#f8f9fa', // Light Gray Surface
            paper: '#ffffff',
        },
        text: {
            primary: '#1f1f1f',
            secondary: '#444746',
        },
        error: {
            main: '#ba1a1a',
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontSize: '2.5rem',
            fontWeight: 500,
        },
        h2: {
            fontSize: '2rem',
            fontWeight: 500,
        },
        h3: {
            fontSize: '1.75rem',
            fontWeight: 500,
        },
        button: {
            textTransform: 'none', // Material 3 uses sentence case usually, but mixed case is fine. No all-caps.
            fontWeight: 500,
        },
    },
    shape: {
        borderRadius: 12, // More rounded corners for M3 feel
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 20, // Pill shape for buttons
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: '0 1px 2px rgba(0,0,0,0.12)',
                    },
                },
                contained: {
                    boxShadow: 'none',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 16,
                    boxShadow: '0 1px 3px 0 rgba(0,0,0,0.12), 0 1px 2px 0 rgba(0,0,0,0.06)', // Soft shadow
                    transition: 'box-shadow 0.2s ease-in-out',
                    '&:hover': {
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                rounded: {
                    borderRadius: 12,
                },
                elevation1: {
                    boxShadow: '0 1px 3px 0 rgba(0,0,0,0.12), 0 1px 2px 0 rgba(0,0,0,0.06)',
                }
            },
        },
        MuiTextField: {
            defaultProps: {
                variant: 'outlined',
                size: 'small',
            },
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 8,
                    }
                }
            }
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#ffffff',
                    color: '#1f1f1f',
                    boxShadow: 'none',
                    borderBottom: '1px solid #e0e0e0',
                }
            }
        }
    },
});

export default theme;
